export const orderIntent=(reference,body)=>{
  const signature=JSON.stringify({...body,price:body.type==='market'?undefined:body.price});
  if(!reference.current||reference.current.signature!==signature)reference.current={signature,key:crypto.randomUUID()};
  return {...body,request_key:reference.current.key};
};